import { solicitar } from '../identidad/cliente-identidad.js'

export type MomentoEvaluacion = 'INTERMEDIA' | 'FINAL'
export interface CriterioRubrica {
  codigo: string
  resultadoAprendizaje: string
  descripcion: string
  pesoGeneral: number
  pesoInterno: number
  orden: number
  procesoPractica: string
  desempenoEstudiante: string
  niveles: Record<string, string>
  aplicaActores: string[]
}
export interface EvaluacionPropia {
  id: string
  actorTipo: string
  momento: MomentoEvaluacion
  version: number
  rubricaVersion: string
  calificaciones: {
    codigo: string
    nota: number
    nivel: string
    observacion: string | null
    ponderado: number
    justificacion_puntaje: string | null
  }[]
}
export const listarRubrica = () =>
  solicitar<{ version: string | null; criterios: CriterioRubrica[] }>(
    '/api/v1/evaluaciones/rubrica-vigente',
  )
export const obtenerPropia = (expedienteId: string, momento: MomentoEvaluacion) =>
  solicitar<EvaluacionPropia | null>(
    `/api/v1/expedientes/${expedienteId}/evaluaciones/${momento}/propia`,
  )
export const guardarPropia = (
  expedienteId: string,
  momento: MomentoEvaluacion,
  notas: {
    codigo: string
    nota: number
    observacion?: string | undefined
    justificacionPuntaje?: string | undefined
  }[],
) =>
  solicitar<{ id: string }>(`/api/v1/expedientes/${expedienteId}/evaluaciones/${momento}/propia`, {
    method: 'PUT',
    body: JSON.stringify({ notas }),
  })
export const obtenerConsolidado = (expedienteId: string) =>
  solicitar<{
    disponible: boolean
    notaFinal: number | null
    nivelFinal: string | null
    resultados: unknown[]
  }>(`/api/v1/expedientes/${expedienteId}/evaluaciones/consolidado`)
export const listarEvaluaciones = (expedienteId: string) =>
  solicitar<
    Array<{
      actor_tipo: string
      actor_nombre: string
      momento: string
      estado: string
      calificaciones: Array<{
        codigo: string
        nota: number
        nivel: string
        observacion: string | null
        justificacion_puntaje: string | null
      }>
    }>
  >(`/api/v1/expedientes/${expedienteId}/evaluaciones`)
